import { Box, Button, Container, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { Link as RouterLink } from 'react-router-dom';
import { CommonHelper } from 'src/utils/commonHelper';

const StyledContent = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  minHeight: '100vh',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  padding: theme.spacing(12, 0),
}));

export default function Page404() {
  const { t: translate } = useTranslation();

  return (
    <>
      <Helmet>
        <title>
          {' '}
          {translate('page404.page404')} | {CommonHelper.GetAppName()}{' '}
        </title>
      </Helmet>

      <Container>
        <StyledContent sx={{ textAlign: 'center', alignItems: 'center' }}>
          <Typography variant="h3" paragraph>
            {translate('no_network.sorry_page_not_found')}
          </Typography>

          <Typography sx={{ color: 'text.secondary' }}>{translate('no_network.mistyped_the_url')}</Typography>

          <Box
            component="img"
            src="/assets/illustrations/illustration_404.svg"
            sx={{ height: 260, mx: 'auto', my: { xs: 5, sm: 10 } }}
          />

          <Button to="/" size="large" variant="contained" component={RouterLink}>
            {translate('no_network.go_home')}
          </Button>
        </StyledContent>
      </Container>
    </>
  );
}
